export const IMG_FILE_EXTENSIONS = ["jpg", "jpeg", "png", "gif"];
export const IMG_UPLOAD_ACCEPTS = IMG_FILE_EXTENSIONS.map(it => '.' + it).join(",");
